import { createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import api from '../../../services/api';

// createSlice makes all action creators and reducers in the same file so no separation of logic is necessary
export const sliceProntuario = createSlice({
  name: 'prontuario',
  initialState: { loading: false, prontuario: {} },
  reducers: {
    prontuarioSuccess: (state, action) => {
      const { prontuario } = action.payload;
      state.loading = false;
      if (prontuario !== undefined) {
        state.prontuario = prontuario;
      }
    },
    prontuarioRequest: state => {
      state.loading = true;
    },
    prontuarioReset: state => {
      state.loading = false;
      state.prontuario = {};
    },
    prontuarioFailure: state => {
      state.loading = false;
      state.prontuario = {};
    },
    prontuarioLoadingOff: state => {
      state.loading = false; // TEMPORÁRIO até o FormProntuarioV2
    },
  },
});

/** *************EXPORTED ACTIONS & REDUCERS************** */

export const {
  prontuarioRequest,
  prontuarioSuccess,
  prontuarioFailure,
  prontuarioReset,
  prontuarioLoadingOff,
} = sliceProntuario.actions;

export default sliceProntuario.reducer;

// API REQUEST ACTIONS HANDLED WITH REDUX-THUNK MIDDLEWARE BUILT INTO REDUX TOOLKIT -->

/** *************THUNKS************** */
export const selectProntuarioById = payload => {
  return async dispatch => {
    try {
      dispatch(prontuarioRequest());
      const result = await api.get(`paciente/prontuario?id=${payload}`);

      const prontuario = Object.assign(
        {},
        { atual: result.data.atual },
        { anterior: result.data.anterior },
        { anteriores: result.data.anteriores }
      );

      dispatch(prontuarioSuccess({ prontuario }));
    } catch (error) {
      toast.error(error?.response?.data?.error || 'Erro ao buscar prontuário!');
      dispatch(prontuarioFailure());
    }
  };
};

// TODO: remover tudo isso abaixo do slice. Slice nao deve existir no FormProntuarioV2
export const insertProntuarioById = payload => {
  return async dispatch => {
    try {
      const result = await api.post(`/prontuario/`, payload);

      const prontuario = Object.assign(
        {},
        { atual: result.data.prontuario.atual },
        { anterior: result.data.prontuario.anterior },
        { anteriores: result.data.prontuario.anteriores },
        { message: result.data.message }
      );

      dispatch(prontuarioSuccess({ prontuario }));
      return prontuario;
    } catch (error) {
      toast.error(
        error?.response?.data?.error || 'Erro ao criar prontuário!'
      );
      dispatch(prontuarioLoadingOff());
      return null;
    }
  };
};

export const updateProntuarioById = payload => {
  return async dispatch => {
    if (!payload?.codconsulta) {
      toast.warn('Erro de validação: consulta não identificada.');
      return null;
    }

    try {
      const result = await api.put(
        `/prontuario/${payload.codconsulta}`,
        payload
      );

      const prontuario = Object.assign(
        {},
        { atual: result.data.prontuario.atual },
        { anterior: result.data.prontuario.anterior },
        { anteriores: result.data.prontuario.anteriores },
        { message: result.data.message }
      );

      dispatch(prontuarioSuccess({ prontuario }));
      return prontuario;
    } catch (error) {
      toast.error(
        error?.response?.data?.error || 'Erro ao atualizar prontuário!'
      );
      dispatch(prontuarioLoadingOff());
      return null;
    }
  };
};
